import React from "react";

import { Hero } from "@/components/Hero";
import { billboardProps } from "@/data/types/home";
import { semHomeThemeAsset } from "@/utils/cdn";
import { Banner } from "../Banner";

export const HeroModule = ({ data }: { data: billboardProps }) => {
  const {
    ctaLabel,
    ctaLink,
    richtext,
    data_qa,
    backgroundColor,
    ctaStyle,
    twoColumns,
    image,
    chips,
  } = data;

  return (
    <Banner
      light
      customBgColor={backgroundColor ?? "neutral-white"}
      customClass="hero-module__banner"
      withoutPadding
      data-testid="hero-module"
    >
      <Hero
        priority
        heroText={richtext}
        cta={{
          ctaLink,
          ctaLabel,
          data_qa,
          ctaStyle,
        }}
        chips={chips}
        twoColumns={twoColumns}
        img={image ?? semHomeThemeAsset("hero-banner.png")}
        size="(max-width: 480px) 256px, (max-width: 768px) 360px, 50vw"
        quality={65}
      />
    </Banner>
  );
};
